// Points of the market value chart.
//
// The server marks a day whose rows are not all in yet with `incomplete: true`
// (a missing portfolio or a clearly partial row count). Such a day is not drawn,
// otherwise the line dives towards zero on the last day. When the live market
// value of the summary header is known, the status date point is set to it so
// the chart ends at the same value as the header.

const isFiniteNumber = (value) =>
  value !== null && value !== undefined && value !== "" && Number.isFinite(Number(value));

export const chartPoints = (chartData, { liveMarketValue = null, statusDate = null } = {}) => {
  const points = (Array.isArray(chartData) ? chartData : []).filter(
    (point) => point && point.incomplete !== true
  );

  if (!isFiniteNumber(liveMarketValue) || !statusDate || points.length === 0) {
    return points;
  }

  const live = Number(liveMarketValue);
  const last = points[points.length - 1];
  const lastDate = String(last.date || "").slice(0, 10);
  const status = String(statusDate).slice(0, 10);

  if (lastDate === status) {
    return [...points.slice(0, -1), { ...last, total_market_value: live }];
  }
  if (lastDate < status) {
    return [...points, { date: status, total_market_value: live }];
  }
  return points;
};

export const chartLiveMarketValue = (live, { chartCurrency = null, tags = null } = {}) => {
  if (!live || !isFiniteNumber(live.value)) return null;
  if (live.currency !== (chartCurrency || "EUR")) return null;
  if (Array.isArray(tags) ? tags.length > 0 : Boolean(tags)) return null;
  return Number(live.value);
};
